import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Stack,
  Text
} from "@chakra-ui/react";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ClientClassificationType } from "models/client_classification_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import {
  OrcamentoDepto,
  OrcamentoDeptoCategoria
} from "models/orcamento_departamento";
import { OptionType } from "models/select_mode";
import { UsuarioModel } from "models/user_model";
import TemplateOrcData from "./TemplateOrcData";
import { MdSave } from "react-icons/md";

interface IFormDeptoOrcamento {
  show: boolean;
  showModal: (show: boolean) => void;
  accountSelected: OrcamentoDepto;
  save: () => void;
  changeInput: (value: any, type: string) => void;
  textColor: string;
  brandStars: string;
  loading: boolean;
  deptoList: ClientClassificationType[];
  borderColor: string;
  changeUser: (item: string) => void;
  selectedUser: UsuarioModel;
  users: UsuarioModel[];
  itens: OrcamentoDeptoCategoria[] | undefined;
  deleteRow: (item: OrcamentoDeptoCategoria) => void;
  addRow: (item: OrcamentoDeptoCategoria) => void;
  errorTitle: string;
  errorMsg: string;
  cancelRef: any;
  closeError: () => void;
  showItemModal: (item: boolean) => void;
  showCategory: boolean;
  saveItem: (order: number) => void;
  changeItem: (item: OrcamentoDeptoCategoria) => void;
  removeItem: (item: OrcamentoDeptoCategoria) => void;
  nomeRef: any;
  reorder: (
    list: OrcamentoDeptoCategoria[],
    startIndex: number,
    endIndex: number
  ) => void;
  drag: boolean;
  isDragable: (drag: boolean) => void;
  condicaoPagamento: CondicaoPagamento[] | undefined;
}

const FormDeptoOrcamento = ({
  show,
  showModal,
  save,
  accountSelected,
  changeInput,
  textColor,
  brandStars,
  loading,
  deptoList,
  borderColor,
  changeUser,
  selectedUser,
  users,
  changeItem,
  condicaoPagamento,
  drag,
  isDragable,
  nomeRef,
  removeItem,
  reorder,
  saveItem,
  showCategory,
  showItemModal,
  addRow,
  cancelRef,
  closeError,
  deleteRow,
  errorMsg,
  errorTitle,
  itens,
}: IFormDeptoOrcamento) => {
  return (
    <Box w={"100%"} h={"100%"}>
      <Box
        px="0px"
        mb="16px"
        mt="0px"
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={4} mb={8}>
          <Button
            onClick={() => {
              save();
            }}
            isLoading={loading}
            leftIcon={<MdSave />}
            colorScheme="brand"
            size={"sm"}
            variant="solid"
          >
            Salvar
          </Button>
        </Stack>
        <SimpleGrid spacing={4} columns={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
            >
              Descrição<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              defaultValue={accountSelected?.descricao}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha a Descrição"
              onChange={(e) => changeInput(e.target.value, "descricao")}
              fontWeight="500"
              size="md"
            />
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
            >
              Departamento<Text color={brandStars}>*</Text>
            </FormLabel>

            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size={"md"}
              onChange={(e) => changeInput(e.value, "depto")}
              placeholder="Buscar..."
              isDisabled={false}
              name={"cliente"}
              defaultValue={{
                label: accountSelected?.departamento?.nome,
                value: accountSelected?.departamento?.id,
              }}
              options={deptoList?.map((item) => {
                return {
                  label: item?.nome,
                  value: item?.id,
                };
              })}
            />
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Validade
            </FormLabel>
            <SingleDatepicker
              name="date-input-validade"
              configs={{
                dateFormat: "dd/MM/yyyy",
                dayNames: "DSTQQSS".split(""), // length of 7
                monthNames:
                  "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                    " "
                  ), // length of 12
                firstDayOfWeek: 0,
                // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
              }}
              propsConfigs={{
                dayOfMonthBtnProps: {
                  selectedBtnProps: {
                    background: "#422afb",
                    color: "white",
                  },
                },
              }}
              date={
                accountSelected?.vigencia !== undefined
                  ? new Date(accountSelected?.vigencia)
                  : new Date()
              }
              onDateChange={(date: any) => {
                changeInput(date, "vigencia");
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Usuário Responsável
            </FormLabel>

            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              placeholder="Busque o Responsável"
              isRequired={true}
              name={"executivo"}
              onChange={(e) => {
                changeUser(e.value);
              }}
              options={users?.map((item) => {
                return {
                  label: item.nome,
                  value: item.id,
                };
              })}
              defaultValue={{
                label: selectedUser?.nome,
                value: selectedUser?.id,
              }}
            />
          </FormControl>
        </SimpleGrid>

        <Text
          textAlign="left"
          color={"black"}
          fontWeight={"bold"}
          fontSize={16}
          mt={16}
        >
          Grupos
        </Text>

        <TemplateOrcData
          showItemModal={showItemModal}
          showCategory={showCategory}
          changeItem={changeItem}
          brandStars={brandStars}
          nomeRef={nomeRef}
          saveItem={saveItem}
          textColor={textColor}
          itens={itens}
          drag={drag}
          isDragable={isDragable}
          removeItem={removeItem}
          reorder={reorder}
          borderColor={borderColor}
        />
      </Box>
    </Box>
  );
};
export default FormDeptoOrcamento;
